export class Roster {
    peers = new Map();
    listeners = new Set();
    staleMs;
    sweepTimer = null;
    snapshotCache = [];
    dirty = true;
    isPaused;
    constructor(opts = {}) {
        this.staleMs = opts.staleMs ?? 300_000;
        this.isPaused = opts.isPaused;
        const sweepMs = opts.sweepMs ?? 30_000;
        if (typeof setInterval !== 'undefined') {
            this.sweepTimer = setInterval(() => this.prune(), sweepMs);
        }
    }
    /** Update / insert a peer entry on receiving its `cap`. */
    upsert(peerId, cap) {
        this.peers.set(peerId, { ...cap, peerId, lastSeen: Date.now() });
        this.dirty = true;
        this.emit();
    }
    /** Explicit removal — Trystero `onPeerLeave` fires this. */
    remove(peerId) {
        if (this.peers.delete(peerId)) {
            this.dirty = true;
            this.emit();
        }
    }
    /** Current peers, freshest-`lastSeen` first. Stable reference between writes. */
    snapshot() {
        if (this.dirty) {
            this.snapshotCache = [...this.peers.values()].sort((a, b) => b.lastSeen - a.lastSeen);
            this.dirty = false;
        }
        return this.snapshotCache;
    }
    /** Subscribe; returns an unsubscribe callback. */
    subscribe(fn) {
        this.listeners.add(fn);
        return () => {
            this.listeners.delete(fn);
        };
    }
    /** For consumers that need the entry without a snapshot scan. */
    get(peerId) {
        return this.peers.get(peerId);
    }
    dispose() {
        if (this.sweepTimer) {
            clearInterval(this.sweepTimer);
            this.sweepTimer = null;
        }
        this.listeners.clear();
        this.peers.clear();
    }
    prune() {
        if (this.isPaused?.())
            return;
        const cutoff = Date.now() - this.staleMs;
        let changed = false;
        for (const [id, e] of this.peers) {
            if (e.lastSeen < cutoff) {
                this.peers.delete(id);
                changed = true;
            }
        }
        if (changed) {
            this.dirty = true;
            this.emit();
        }
    }
    emit() {
        const snap = this.snapshot();
        for (const fn of this.listeners)
            fn(snap);
    }
}
